import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const heartAttack: AnswerPathTreeNode = {
  path: 'heartAttack',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredHeartAttackDetails }],
};
